import FORMS from './constants';

import registrarUserFormConfig from './forms/registrarUserFormConfig';
import registrarUserOrgFormConfig from './forms/registrarUserOrgFormConfig';
import registrarUserOrgResultFormConfig from './forms/registrarUserOrgResultFormConfig';

import smsCodeFormConfig from './forms/smsCodeFormConfig';
import errorDialogFormConfig from './forms/errorDialogFormConfig';

import passwordFormConfig from './forms/passwordFormConfig';
import passwordHintsConfig from './forms/passwordHintsConfig';

import userInfoConfig from './forms/userInfoConfig';

import errorFormConfig from './forms/errorFormConfig';

const configs = {
  [FORMS.REGISTRAR_USER]: registrarUserFormConfig,
  [FORMS.REGISTRAR_USER_ORG]: registrarUserOrgFormConfig,
  [FORMS.REGISTRAR_USER_ORG_RESULT]: registrarUserOrgResultFormConfig,
  [FORMS.SIGN_SMS]: smsCodeFormConfig,
  [FORMS.ERROR_DIALOG]: errorDialogFormConfig,
  [FORMS.PASSWORD]: passwordFormConfig,
  [FORMS.PASSWORD_HINT]: passwordHintsConfig,
  [FORMS.USER_INFO]: userInfoConfig,
  [FORMS.ERROR_FORM]: errorFormConfig
};

const getById = id => {
  return configs[id];
};

const getIdByName = name => {
  return Object.keys(configs).find(key => {
    return configs[key] && configs[key].instanceName === name;
  });
};

const getByName = name => {
  const key = getIdByName(name);
  return key ? configs[key] : null;
};

export default {
  getById,
  getIdByName,
  getByName
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/formsConfigs.js